import { Component, Input } from '@angular/core';

@Component({
  selector: 'nrwl-no-data',
  templateUrl: './no-data.component.html',
  styleUrls: ['./no-data.component.scss']
})
export class NoDataComponent {
  @Input() format = 'topMargin'; // (topMargin | minimal | padded | smallPadded)
  @Input() detailMessage: string;
}
